export default {
  fa: "invalid_api_key",
  ma: "blacklisted",
  pa: "no_device_identifier",
  la: "invalid_json_response",
  ca: "empty_response",
  __: "sdk_auth_error"
};
